import { render } from "./RejectAction.vue?vue&type=template&id=4b6da5d6"
import script from "./RejectAction.vue?vue&type=script&lang=js"
export * from "./RejectAction.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__